import { TStyles } from "utils/Styles";

const styles: TStyles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    pt: 3,
    pb: 3,
    flex: 1,
  },

  cardContainer: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    flexDirection: "column",
  },

  layoutContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    zIndex: (theme) => theme.zIndex.modal,
    height: "auto",
    border: "none",
  },
};

export default styles;
